
const hasRight = function (buttonList,code) {
    let hasright = buttonList.find(x => x.path === code) != null
    console.log(hasright ? "有权限" : "没权限", code)
    return hasright;
}

// 注册一个全局自定义指令 `v-auth`
const permission = function (el, binding, vnode) {
    let code = binding.value;
    if (!hasRight(code)) {
        el.parentNode && el.parentNode.removeChild(el)
    }
}
const install = function(Vue){
    Vue.prototype.$hasRight = hasRight;
    Vue.directive('auth',{ inserted: permission });
}

if(Window.Vue){
    Vue.use(install);
}

permission.install = install;
export default permission